import { useContext } from 'react';
import SignupForm from "./Form";
import { GoogleLoginButton } from "react-social-login-buttons";
import { registerUserAction, registerWithGoogleAction } from '../../Context/Auth/actions';
import { AuthContext } from '../../Context/Auth';
import googleAuth from '../googleAuth';
import {toast} from 'react-toastify';
import Loader from '../../Components/Lottie';
import loader from '../../Assets/json/spinner.json';


const Signup = ({
    shouldLogin,
    googleAuthHandler
}) => {

  const { authState, dispatch } = useContext(AuthContext);

  const registerUserHandler = (formInput) => {
    dispatch(registerUserAction(formInput))
  };

  const googleAuthCallback = (error, id) => {
    if (error) {
      if (error.error === "popup_closed_by_user") {
        return;
      }
      toast.error("Sorry, You can't login in with Google");
      return;
    }

    dispatch(registerWithGoogleAction({
      idToken: id
    }));
  };


  return (
    <div className="pt-5 md:pt-30">
      <SignupForm authState={authState}  registerUserHandler={registerUserHandler} />
      <div className="mt-4">
        <GoogleLoginButton onClick={() => googleAuthHandler(googleAuthCallback)} className="google_btn">
        {!authState?.registeringWithGoogle && (
            <span className="text-xs ml-2 text-boudoir">SIGNUP WITH GOOGLE</span>
          )}
          {authState?.registeringWithGoogle && (
            <span className="ml-2 flex items-center justify-center">
              <span className="w-5 h-5">
                <Loader loader={loader} />
              </span>
            </span>
          )}
        </GoogleLoginButton>
      </div>
      <span className="text-10px mt-3 inline-block text-center text-seal w-full md:text-xs md:leading-4">
          
          Already have an account? <button onClick={shouldLogin} className="text-chestNut">Login</button>
      </span>
    </div>
  );
};
 
export default googleAuth(Signup);